







































import { Component, Vue, Prop } from 'vue-property-decorator'

import CustomerNotificationsList from '@/components/CustomerNotificationsList.vue'
import HeaderUserWidget from '@/components/HeaderUserWidget.vue'

import CustomerNotification from '@/models/customer-notification'

import EventBus from '@/event-bus'
import { CustomerNotificationsActionTypes } from '@/store/modules/customerNotifications'

@Component({
  components: {
    CustomerNotificationsList,
    HeaderUserWidget,
  },
})
export default class Header extends Vue {
  @Prop() customerName!: string
  @Prop() notifications!: CustomerNotification[]

  userWidgetPopupVisible = false
  customTitle: null | string = null

  created() {
    EventBus.$on('set-custom-authenticated-header-title', (title: string) => {
      this.customTitle = title
    })
  }

  get unreadNotificaionsAmount(): number {
    return this.notifications.filter((notification) => !notification.seen)
      .length
  }

  get headerTitle() {
    const { customerName, customTitle, companyName } = this
    return (
      customTitle || `Welcome to your ${companyName} account, ${customerName}!`
    )
  }

  markNotificationsAsSeen() {
    this.$store.dispatch(
      CustomerNotificationsActionTypes.MarkAsSeen,
      this.notifications.map((n) => n.id),
    )
  }
}
